import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useTokenStore from '../../stores/tokens';
import { compatApi } from '../../utils/Intercepter';
import { PURPLE, MINT } from '../../utils/designUtils';

export default function MyInfoCheckPw() {
    const { setTokens, setUser } = useTokenStore();
    const navigate = useNavigate();

    // eslint-disable-next-line no-unused-vars
    const [userEmail, setUserEmail] = useState('');
    const [userPassword, setUserPassword] = useState('');

    const handleSubmit = async (event) => {
        event.preventDefault();
        const credentials = { userEmail, userPassword, clientId: "workitalk-web" };

        try {
            await compatApi.post("/my-info/check-pw", credentials);
            navigate('/my-info/details');
        } catch (error) {
            console.log(error.response.data.message);
            if (error.response) {
                const status = error.response.status;
                if (status === 400) {
                    alert('잘못된 요청입니다.');
                } else {
                    alert(error.response.data.message);
                }
            } else {
                alert('네트워크 오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
            }
        }
    };

    // eslint-disable-next-line no-unused-vars
    const onTokenSetting = async (data) => {
        if (data.accessToken && data.refreshToken) {
            setTokens(data.accessToken, data.refreshToken);
        }
        console.log('토큰 저장 완료', data);
        setUser({
            userName: data.userName,
            userEmail: data.userEmail,
            orgUserList: data.orgUserList,
            isAdmin: data.admin
        });
    };

    const label = { display: 'block', fontWeight: 600, marginBottom: 6, color: '#1f1d2e', fontSize: 14 };
    const inputStyle = {
        width: '100%', padding: '12px 14px', borderRadius: 10,
        border: '1.5px solid #e5e0f7', outline: 'none', fontSize: 14,
        color: '#1f1d2e', background: '#faf9fe', boxSizing: 'border-box', boxShadow: 'none'
    };

    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 'calc(100vh - 61px)', background: '#f5f4fa' }}>
            <div style={{ background: '#fff', borderRadius: 16, boxShadow: '0 4px 24px rgba(124,107,217,0.10)', border: '1px solid rgba(124,107,217,0.12)', padding: '40px', width: '100%', maxWidth: 440 }}>
                <h2 style={{ textAlign: 'center', fontWeight: 700, marginBottom: 28, color: '#1f1d2e', fontSize: 20 }}>
                    비밀번호 확인
                </h2>
                <form onSubmit={handleSubmit} style={{ maxWidth: 'none', margin: 0, padding: 0, border: 'none', borderRadius: 0, background: 'none' }}>
                    <div style={{ marginBottom: 20 }}>
                        <label style={label}>비밀번호</label>
                        <input
                            name="userPassword"
                            type="password"
                            placeholder="비밀번호"
                            autoComplete="off"
                            value={userPassword}
                            onChange={(e) => setUserPassword(e.target.value)}
                            style={inputStyle}
                        />
                    </div>
                    <button
                        type="submit"
                        disabled={!userPassword}
                        style={{
                            display: 'block', width: '100%', padding: '13px', borderRadius: 10,
                            background: userPassword ? `linear-gradient(135deg, ${PURPLE}, ${MINT})` : '#e5e0f7',
                            color: userPassword ? '#fff' : '#a0a0b0',
                            fontWeight: 700, fontSize: 15, border: 'none',
                            cursor: userPassword ? 'pointer' : 'not-allowed'
                        }}
                    >
                        비밀번호 확인
                    </button>
                </form>
            </div>
        </div>
    );
}
